import $ from '@sparta.global.vendors/jquery';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sales.modules/es-en-interstitial-module",
  "version": "1.0.2",
  "id": "esEnInterstitial",
  "containerID": "salesEsEnInterstitialModule",
  "moduleName": "sales-es-en-interstitial-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "es-en-interstitial-module",
  "data": {
    "init": "esEnInterstitial",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/*
 * tab-nav-module
 * module_js_id: esEnInterstitial
 *
 * Copyright (c) 2016-6-27 me
 */

/* eslint-disable no-param-reassign */

/**
 * @export
 * @class esEnInterstitial
 * @extends {Module}
 */
class esEnInterstitial extends Module {
  /**
   * Creates an instance of esEnInterstitial.
   * @param {*} options object
   * @param {*} context object
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#esEnInterstitial');

    // Grab all method names except for init & constructor
    const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(this)).filter(method => ['constructor', 'init'] && typeof this[method] === 'function');
    methods.forEach(method => this[method].bind(this));

    // exceptions
    this.exceptions = [{
      type: 'id',
      value: 'english-route-to'
    }, {
      type: 'class',
      value: 'no-interstitial'
    }];
  }

  /**
  * bypassException
  * @param {*} e object
  * @returns {boolean} returns if there are exceptions
  */
  bypassException(e) {
    const $cache = e;
    const {
      exceptions
    } = this;

    /* eslint-disable no-restricted-syntax */
    /* eslint-disable no-extra-boolean-cast */
    for (const i in exceptions) {
      if (!!exceptions[i]) {
        const attr = $cache.attr(exceptions[i].type) || '';
        const arrAttr = attr.split(/\s+/g);
        // if exception matches then return true
        if (arrAttr.includes(exceptions[i].value)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Creates an instance
   * @returns {void}
   */
  init() {
    const self = this;
    const spanish = window.location.pathname.includes('/es/');

    // is page Spanish? (check LANG)
    if (spanish) {
      // wait a few seconds in case there is other js on the page that alters links
      setTimeout(() => {
        const $englishLinks = $("a:not([href$='/es/']), a:not([href$='/es'])");

        /* eslint-disable consistent-return */
        /* eslint-disable func-names */
        $englishLinks.each(function () {
          const $el = $(this);

          // if exception then continue
          if (self.bypassException($el)) {
            return true;
          }
          const href = $el.attr('href') || '';

          // do a double check to ensure we're not a spanish link
          if (!/(\/es|locale=es_)/.test(href)) {
            // href needs to look like link or be a link
            if (/^\/[A-z0-9-]+/.test(href) || href.includes('http') || href.includes('www.')) {
              // only add if something isn't already declared
              if (!($el.attr('data-options') && $el.attr('data-options').indexOf('interstitialType') !== -1)) {
                $el.addClass('spa-ui-layer-link spa-fn').attr('data-options', '{"interstitialType": "language-change", "interstitialBranding": "default"}');
              }
            }
          }
        });
      }, 2000);
    }
  }
}
registerModuleClass({
  moduleClass: esEnInterstitial,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { esEnInterstitial as default, moduleConfig };
